module.exports = __webpack_public_path__ + "img/wallet-invoices.9deb4cd1.png";